var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 6V24H3V0H15L21 6ZM4 23H20V7H14V1H4V23ZM15 6H19.5L15 1.5V6Z",
    fill: "#F4F4F4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 12,
    width: 20,
    height: 9,
    rx: 1,
    fill: "#C80404"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98306 14.006C8.132 14.0099 9 14.4556 9 16.0041C9 17.5041 7.99005 18.0193 6.94345 18.0157H5.98061V18.9945L5 18.9979L5.01296 14.006H6.98306ZM7 17.0041C7.70977 17.0065 7.9983 16.6412 8 16.0041C8.0017 15.3671 7.70973 15.0064 7 15.0041H6L5.98061 17.0041H7ZM10.013 14.0038H12C13.4303 14.0086 14.0035 15.1335 14 16.5038C13.9964 17.8828 13.4374 19.0034 12 18.9987L10 18.9956L10.013 14.0038ZM12 18.0157C12.9918 18.019 13 17.1366 13 16.5038C13 16.0041 12.9692 15.0071 12 15.0038H11V18.0038L12 18.0157ZM16 15V15.9997L18 16V16.9997H16V18.9946L15 18.9919L15.013 14L19 14.0083V15H16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfDark);
export default __webpack_public_path__ + "static/media/pdf_dark.1f4f5cebaac78614994aa83d77dc6ab0.svg";
export { ForwardRef as ReactComponent };